import { render, staticRenderFns } from "./ElectricianEdit.vue?vue&type=template&id=47323c7f&scoped=true"
import script from "./ElectricianEdit.vue?vue&type=script&lang=js"
export * from "./ElectricianEdit.vue?vue&type=script&lang=js"
import style0 from "./ElectricianEdit.vue?vue&type=style&index=0&id=47323c7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47323c7f",
  null
  
)

export default component.exports